<script setup lang="ts">
import { useDocumentSelfAssessmentStore } from "~/composables/useDocumentSelfAssessmentStore";
import { isAssignmentReferenceChecklistDraft } from "~/utils/assignment-reference-checklist";

const emit = defineEmits(["onSubmitted"]);

const documentId = inject("documentId") as any;
const documentSelfAssessmentStore = useDocumentSelfAssessmentStore(documentId);
const { isInitialized } = storeToRefs(documentSelfAssessmentStore);

const documentChecklistStore = useDocumentChecklistStore(documentId);
const {
  isOSS,
  hasCorrectNumberOfBodyParagraphs,
  numExpectedBodyParagraphs,

  hasShownMissmatchMessage,
  isInitialized: isChecklistInitialized,
} = storeToRefs(documentChecklistStore);

const docStore = useSubmittedDocumentStore(documentId);
const { revision, submittedDocument, isDocumentInitialized, isEditingMode } =
  storeToRefs(docStore);

const isReferenceChecklistMode = computed(() =>
  isAssignmentReferenceChecklistDraft(submittedDocument.value)
);

const isLoading = computed(() => {
  return (
    isChecklistInitialized.value != true ||
    revision.value == undefined ||
    isInitialized.value != true
  );
});

watch(isChecklistInitialized, async () => {
  if (isChecklistInitialized.value == true) {
    await documentSelfAssessmentStore.initialize();
  }
});
</script>

<template>
  <div class="h-full">
    <div class="bg-surface w-full h-full min-w-[500px] max-w-[500px]">
      <DocumentStudentEditingReferenceChecklistReview
        v-if="isReferenceChecklistMode && revision"
        @on-submitted="emit('onSubmitted')"
      />
      <div v-else-if="isLoading" class="flex flex-col">
        <div class="flex flex-row items-center gap-2 border-b pb-1 px-2 pt-4">
          <h2 class="text-h5 font-bold">
            <BaseSkeleton class="w-[400px] h-[20px] mb-1" />
          </h2>
        </div>
        <div class="py-4 px-2">
          <BaseSkeleton class="w-full h-[20px]" />
          <div class="mt-2 rounded border p-2">
            <div class="flex flex-row item-center justify-between gap-2">
              <BaseSkeleton class="w-[250px] h-[20px]" />
              <BaseSkeleton class="w-[20px] h-[20px]" />
            </div>
            <BaseSkeleton class="w-[300px] h-[20px] mt-2" />
          </div>
        </div>
      </div>
      <DocumentSelfAssessmentContainer
        v-else
        :document-id="documentId"
        @on-submitted="
          () => {
            emit('onSubmitted');
          }
        "
      />
    </div>
  </div>
</template>

<style scoped></style>
